<template>
  <div class="returnable-orders container">
    <alert-box
      v-for="alert in alerts"
      :key="alert.message"
      :type="alert.type"
    >
      {{ alert.message }}
    </alert-box>

    <div
      v-if="orders.length > 0"
      class="row returnable-orders"
    >
      <div class="col-md-12">
        <order-table
          :orders="orders"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import alerts from 'mixins/storefront/cart-alerts'
  import OrderTable from "./reimbursement-request/order-table";

  export default {
    components: {
      OrderTable,
    },
    mixins: [alerts],
    props: {
      ordersPath: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        orders: [],
      };
    },
    created() {
      axios
        .get(this.ordersPath)
        .then((response) => {
          switch (response.status) {
            case 200:
              this.orders = response.data.orders;
              break;
            case 422:
              response.data.errors.forEach((error) => {
                this.alert(error, 'danger');
              });
              break;
            default:
              break;
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            error.response.data.errors.forEach((message) => {
              this.alert(message, "danger")
            })
          } else {
            this.alert(error.message || error, "danger")
          }
        });
    },
  };
</script>
